import type { LottoDb, LottoDbKr } from '../types/lotto';

async function loadJson<T>(url: string): Promise<T | null> {
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    return (await res.json()) as T;
  } catch {
    return null;
  }
}

export function loadUsDb(): Promise<LottoDb | null> {
  return loadJson<LottoDb>('/lotto-db.json');
}

export function loadKrDb(): Promise<LottoDbKr | null> {
  return loadJson<LottoDbKr>('/lotto-db-kr.json');
}
